<template>
    <div class="loading-spinner flex align-items-center justify-content-center">
        <i class="pi pi-spin pi-spinner text-2xl" />
        <span v-if="label" class="ml-2">{{ label }}</span>
    </div>
</template>

<script setup lang="ts">
interface Props {
    label?: string;
}

defineProps<Props>();
</script>
